"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLocalesTest = makeLocalesTest;
function makeLocaleMatcher(target) {
    return Object.entries(target).reduce((obj, [key, value]) => ({
        ...obj,
        [key]: typeof value === 'string' ? expect.any(String) : makeLocaleMatcher(value)
    }), {});
}
const langs = ['en', 'ru'];
/**
 * @public
 * @param loader -
 * @returns
 */
function makeLocalesTest(loader) {
    return async () => {
        const [target, ...rest] = await Promise.all(langs.map(loader));
        const matcher = makeLocaleMatcher(target);
        rest.forEach((loc) => {
            expect(loc).toEqual(matcher);
        });
    };
}
//# sourceMappingURL=testUtils.js.map